var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAwesomeBookReader = function SvgIconAwesomeBookReader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.704,
    height: 43.704,
    viewBox: "0 0 43.704 43.704",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-reader",
    "data-name": "Icon awesome-book-reader",
    d: "M30.046,8.194a8.194,8.194,0,1,0-8.194,8.194A8.194,8.194,0,0,0,30.046,8.194ZM19.939,20.58c-5.064-3.1-13.267-3.952-17.4-4.187A2.362,2.362,0,0,0,0,18.705V37.723a2.348,2.348,0,0,0,2.261,2.309c3.727.2,11.266.912,16.478,3.536a1.188,1.188,0,0,0,1.748-1.013v-21a1.136,1.136,0,0,0-.548-.978ZM41.16,16.393c-4.127.234-12.331,1.087-17.394,4.187a1.157,1.157,0,0,0-.547.993v20.98a1.192,1.192,0,0,0,1.753,1.016c5.21-2.622,12.746-3.338,16.472-3.534a2.349,2.349,0,0,0,2.261-2.31V18.705A2.363,2.363,0,0,0,41.16,16.393Z",
    fill: "#b0b0b0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeBookReader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-awesome-book-reader.b7b42790f5a22600e36fd5098f60bc69.svg";